"use client";

import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "viewportClassName", "children"];
var __jsx = React.createElement;
import * as React from "react";
import classNames from "classnames";
export var ScrollArea = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    viewportClassName = _ref.viewportClassName,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: classNames("relative overflow-hidden", className)
  }, props), /*#__PURE__*/React.createElement("div", {
    className: classNames("h-full w-full overflow-auto scrollbar-light dark:scrollbar", viewportClassName)
  }, children));
});
ScrollArea.displayName = "ScrollArea";